import React, { FC, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { LAUNCHDARKLY_INFO } from 'helpers/global.config';
import Layout from 'components/Layout';
import Loading from 'components/Loading';

const LandingPage = lazy(() => import('containers/LandingPage'));
const LogPage = lazy(() => import('containers/LogPage'));
const NotFoundPage = lazy(() => import('containers/NotFoundPage'));
const ManifestPage = lazy(() => import('../providers/manifest/containers/ManifestPage'));

const App: FC = () => {

  return (
    <Router>
      <Layout>
        <Suspense fallback={<Loading isLoading={true} />}>
          <Switch>
            <Route path="/" exact component={LandingPage} />
            <Route path="/logs" exact component={LogPage} />
            <Route path="/delivery/:provider" exact component={ManifestPage} />
            <Route path="/notfound" component={NotFoundPage} />
            <Route component={NotFoundPage} />
          </Switch>
        </Suspense>
      </Layout>
    </Router>
  );
};

// initialize LaunchDarkly provider with anonymous context before providing orgId in LandingPage
export default withLDProvider({
  clientSideID: import.meta.env.VITE_ENVIRONMENT_NAME === 'prod' ? LAUNCHDARKLY_INFO.prodId : LAUNCHDARKLY_INFO.stagingId,
  context: LAUNCHDARKLY_INFO.initialContext,
})(App);
